import { Container, Divider, Link, useTheme } from '@mui/material';

import { StackRowForm } from 'src/components';
import { contactFormConfig } from 'src/components/forms/hubspot-config';
import HubspotContactForm from 'src/components/forms/HubspotContactForm';
import { useToggle } from 'src/hooks/useToggle';

//
//

export const Footer = () => {
  const theme = useTheme();
  const toggle = useToggle();

  const DividerLine = (
    <Divider
      orientation="vertical"
      flexItem
      sx={{ color: (theme) => theme.palette.text.secondary }}
    />
  );

  return (
    <Container maxWidth="lg">
      <StackRowForm
        justifyContent="center"
        alignItems="center"
        direction={{ xs: 'column', md: 'row' }}
        gap={{ xs: 1, md: 2 }}
        sx={{
          mb: 2,
          '& > *': (theme) => ({
            ...theme.typography.body1,
            color: (theme) => `${theme.palette.text.secondary} !important`,
            textDecoration: 'none',
          }),
          [theme.breakpoints.down('md')]: {
            '& .MuiDivider-root': {
              display: 'none',
            },
          },
        }}
      >
        <Link href="https://www.carbonclick.com/terms-of-use" target="_blank">
          Terms & Conditions
        </Link>

        {DividerLine}

        <Link href="https://www.carbonclick.com/privacy-policy" target="_blank">
          Privacy Policy
        </Link>

        {DividerLine}

        <Link href="https://www.carbonclick.com/faqs" target="_blank">
          FAQs
        </Link>

        {DividerLine}

        <Link onClick={toggle.on}>Contact us</Link>

        {DividerLine}

        <Link href="https://www.carbonclick.com" target="_blank">
          CarbonClick
        </Link>
      </StackRowForm>

      {toggle.value && (
        <HubspotContactForm
          isModalOpen={toggle.value}
          setIsModalOpen={toggle.setValue}
          region={contactFormConfig.region}
          portalId={contactFormConfig.portalId}
          formId={contactFormConfig.formId}
        />
      )}
    </Container>
  );
};
